
import {styled} from '@mui/material/styles';
import Container from '@mui/material/Container';
// import CircularProgress from '@mui/material/CircularProgress';
// // import Alert from '@mui/material/Alert';
// import { useTranslation } from 'react-i18next';

import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    Card,
    FlexBLock,
    WhiteSpaceVertical,
    Dialog,
    LoadingBlock,
    Tips
} from '../../components';

import {IconImg} from '../../components/Icon'

import {
    WeiToUnits,
    EtherToWei,
    EtherToInt,
} from '../../ethers/e'

import {
    useStairData,
    useBuyOrder,
    useClaimStair,
    useWithdrawOrder,
    useReInvestOrder
} from '../../hook/ma/useNode'

import useCountdown from '../../hook/useCountdown'

import {
    useBalance
} from '../../context/balance'
import { useEffect } from 'react';

import {ProtocolSignDrawer} from '../Protocol'

function getUrl() {
    const rul = window.location.href.match(/stair/)
    return rul
}

function ComingSoon() {
    return <Button type='b' style={{width: '100%'}}>Coming Soon</Button>
}

function Updating() {
    return <Button type='b' style={{width: '100%'}}>Updating</Button>
}

function BuyStairsSwitch({stair}) {
    /** 当 url 为 stair 时 用 Buystairs ，否则 用 comingsoon 组建 */
    // const urlParams = getUrl()

    // console.log(urlParams)
    return (
        // urlParams === null ?
        // <ComingSoon /> :
        // {/* <ComingSoon /> */}
        <BuyStairs
            sponsor={stair.sponsor}
            initialVip={stair.initialVip}
            initialVipRate={stair.initialVipRate}
            maxInvestable={stair.maxInvestable}
        />
    )
}

function BuyStairs({sponsor, initialVip, initialVipRate, maxInvestable}) {
    const {balances} = useBalance() 
    const {
        button,
        buttonCVCD,
        amountInput,
        sponsorInput,
        hashInput
    } = useBuyOrder()

    const registed = sponsor*1 > 0
    useEffect(() => {
        if (sponsor*1 > 0) {
            sponsorInput.onChange(sponsor)
        }
    }, [sponsor])

    const requireSign = hashInput.value === '' && !registed

    const disableBuy = amountInput.value*1 > maxInvestable*1
    buttonCVCD.disabled = balances.CVCD*1 < amountInput.value*1 || disableBuy
    button.disabled = balances.USDT*1 < amountInput.value*1 || disableBuy


    return (
        <>
            <TextS>Balance <TextLinear>{EtherToInt(balances.USDT)}</TextLinear> USDT · <TextLinear linear='2'>{EtherToInt(balances.CVCD)}</TextLinear> CVCD</TextS>
            <Input
                after={<Button size='small' type='d' onClick={()=>{
                    const max = Math.max(balances.USDT, balances.CVCD)
                    amountInput.onChange(Math.min(maxInvestable*1, max))
                }}>Max</Button>}
                input={amountInput}
            />
            {
                disableBuy && <TextS fail>Max {EtherToInt(maxInvestable)}</TextS>
            }

            <WhiteSpace />
            <FlexBLock>
                <TextS color='2'>Max Investable</TextS>
                <TextS>{EtherToInt(maxInvestable)} <TextS color='2'>CVCD·USDT</TextS></TextS>
            </FlexBLock>
            <FlexBLock>
                <TextS color='2'>Initial Level</TextS>
                <TextS><NodeType>VIP{initialVip}</NodeType> <NodeType i='2'>+{initialVipRate}%</NodeType></TextS>
            </FlexBLock>
            
            {
                !registed && 
                <>
                    <TextS>Sponsor Address</TextS>
                    <Input
                        input={sponsorInput}
                    />
                </>
            }

            
            <WhiteSpace />
            <Updating />
            {/* {

                requireSign ? 
                <ProtocolSignDrawer
                    buttonStyle={{
                        type:'b',
                        style: {width: '100%'}
                    }}
                    onComfirm={hash => {
                        hashInput.onChange(hash)
                    }}
                />:
                <FlexBLock>
                    <Button type='b' style={{width: '49%'}} {...buttonCVCD} />
                    <Button type='d' style={{width: '49%'}} {...button} />
                </FlexBLock>
            } */}
            
        </>
    )
}


function Countdown({end, children}) {
    const countdown = useCountdown(end, (hours, minutes, seconds) => {
        let days = Math.floor(hours / 24)
        return `${days > 0 ? days+'D': ''} ${hours % 24}:${minutes}:${seconds} `
    })
    return countdown === 'Ended' ? children : <TextS style={{fontSize: '16px'}}>{countdown}</TextS>
}

function SetOrder({id, vip}) {
    const wButton = useWithdrawOrder(id)
    const rButton = useReInvestOrder(id)

    return (
        <>
            <Button size='small' style={{marginRight: '4px'}} {...wButton}/>
            { vip === 52 ? null : <Button size='small' type='d' {...rButton}/> }
        </>
    )
}

function ClaimButton() {
    return <Button {...useClaimStair()} disabled={true} />
}



function Stairs() {
    const stair = useStairData()
    return (
        <Container>
            <TextMax><IconImg style={{width: '26px', height: 'auto', verticalAlign: 'inherit'}} src='./pyramid.png'/> Ladder Program</TextMax>
            <WhiteSpace />
            <Card type='j'>
                <FlexBLock>
                    <div>
                        <TextM block>My Stair Reward</TextM>
                        <TextLinear style={{fontSize: '24px'}} block>{EtherToInt(0)}</TextLinear> <TextM color='2'> / CVCD</TextM>
                        <TextS color='2' block>My Total Reward <TextS >{EtherToInt(stair.totalRewarded)}</TextS> CVCD</TextS>
                    </div>
                    <ClaimButton />
                </FlexBLock>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <TextS color='2'>Cumulative Differential Profit</TextS>
                    <TextS>{EtherToInt(stair.totalOrderRewarded)} <TextS color='2'>CVCD</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>Max Differential Profit <Tips type='a'>X3</Tips></TextS>
                    <TextS>{EtherToInt(stair.orderNetTnvest * 3)} <TextS color='2'>CVCD</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>My Level </TextS>
                    <TextS><NodeType>VIP{stair.vip}</NodeType> <NodeType i='2'>+{stair.vipRate}%</NodeType></TextS>
                </FlexBLock>
                {/* <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <BuyStairsSwitch stair={stair}/> */}
            </Card>
            <WhiteSpace />
            <Card>
                <TextM block>My Orders Total locked</TextM>
                {/* <WhiteSpace /> */}
                <TextLinear style={{fontSize: '24px'}} block>{EtherToInt(stair.totalLocked)}</TextLinear> <TextM color='2'> / CVCD</TextM>
                {/* <TextS color='2'>Total locked <TextLinear>{EtherToInt(stair.totalLocked)}</TextLinear> CVCD</TextS> */}
                {/* <FlexBLock>
                    <TextS color='2'>Total locked</TextS>
                    <TextS><TextLinear>{EtherToInt(stair.totalLocked)}</TextLinear> CVCD</TextS>
                </FlexBLock> */}
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <LoadingBlock loading={stair.registed === null}>
                    {
                        stair.orders.filter(v => v.invested*1 > 0).map(v => {
                            return (
                                <div key={v.id}>
                                    <FlexBLock style={{padding: '6px 0 12px'}}>
                                        <div>
                                            <TextS block color='2'>Position <NodeType>VIP{v.vip}</NodeType> <NodeType i='2'>+{v.vipRate}%</NodeType></TextS>
                                            <TextM style={{margin: '2px 0px'}}>{EtherToInt(v.invested)} <TextS color='2'>CVCD</TextS></TextM>
                                            <TextS block color='2'>Start Time : {v.startDate} | <NodeType i='2'>{v.cycle} Round</NodeType></TextS>
                                        </div>
                                        {
                                            v.closed ?
                                            <TextM color='2'>Eended</TextM>:
                                            <div>
                                                {/* <Countdown end={v.unlockEnd}>
                                                    <SetOrder id={v.id} vip={v.vip}/>
                                                </Countdown> */}
                                                <TextM color='2'>Updating</TextM>
                                                {/* <SetOrder id={v.id} vip={v.vip}/> */}
                                            </div>
                                        }
                                    </FlexBLock>
                                    <Hr />
                                </div>
                            )
                        })
                    }
                </LoadingBlock>
            </Card>
        </Container>
    )
}

export default Stairs

const COLOR = [
    "rgb(171 255 0)",
    "rgb(255 199 0)",
    "rgb(255 241 0)",
    "rgb(255 0 161)",
    "rgb(0 242 255)",
]
function NodeType({children, i = 0}) {
    return <NodeBlock i={i}>{children}</NodeBlock>
}

const NodeBlock = styled('span')`
    background-color: ${p => COLOR[p.i] || COLOR[0]};
    color: #000;
    font-size: 10px;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 4px;
    box-shadow: 0px 0px 6px #fdffb791;
`
